/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-10-20
 * @brief EHP WorkOrder 개발
 *
 ********************************************************************/
import React, { useState } from "react";
//recoil
import { useRecoilValue, useRecoilState } from "recoil";
import { loadingBoxState, treeMenuState } from '../../recoil/menuState';
//ex-component
import $ from "jquery";
// utils
import * as CONST from "../../utils/Const";
import * as CUTIL from "../../utils/commUtils";
//component
import EhealthCheckMain from "./workorder/ehealthcheck/EhealthCheckMain";
import WorkInspectionMain from "./workorder/inspection/WorkInspectionMain";
import WorkHistoryList from "./workorder/histoty/WorkHistoryList";
import ChangeMain from "./workorder/change/ChangeMain";
/**
 * @brief EHP WorkOrder 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ServiceRequestSubMain(props) {
    //recoil
    const isLoadingBox = useRecoilValue(loadingBoxState);
    const [treeOpen, setRecoilTreeOpen] = useRecoilState(treeMenuState);
    //props
    const setParentPopWin = props.setPopWin;
    const tabMenuList = props.tabMenuList;
    const curTabMenu = props.curTabMenu;
    const setParentCurTabMenu = props.setCurTabMenu;
    //const menuItem = props.menuItem
    /*
    const subTabMenuList = [
      { tabId: 0, tabName: "e-Health Check", tabUrl: CONST.URL_SERVICEWORKORDER, tabType: "TAB_EHC" },
      { tabId: 1, tabName: "점검출동", tabUrl: CONST.URL_SERVICEWORKORDER, tabType: "TAB_INSPECTION" },
      { tabId: 2, tabName: "점검/사고이력", tabUrl: CONST.URL_SERVICEWORKORDER, tabType: "TAB_HISTORY" },
      { tabId: 3, tabName: "노후교체 컨설팅", tabUrl: CONST.URL_SERVICEWORKORDER, tabType: "TAB_CHANGE" },
    ];
  
    const [tabMenuList, setTabMenuList] = useState(subTabMenuList);
    const [curTabMenu, setCurTabMenu] = useState(subTabMenuList[0]);
    */
    const [nodata, setNodata] = useState();
    // option 선택 시  값 변경 액션
    function selectTabOption(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //setCurTabMenu(JSON.parse(optionData)); // 탭 또는 모바일 경우
        setParentCurTabMenu(JSON.parse(optionData)); // 탭 또는 모바일 경우
    }
    function onClickTab(e) {
        var actTag = (e.target.tagName === "DIV") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        //setCurTabMenu(tabInfo);
        setParentCurTabMenu(tabInfo);
        //
        setParentPopWin("pop-list-ehcdetailview", null);
        setParentPopWin("pop-list-view", null);
    }
    function onClickMoblieTreeMenu(e) {
        //트리메뉴 모바일
        e.preventDefault();
        //$(this).parent().children().children().children().children().children(".area__left").addClass("active");
        //$(this).parent().children().children().children().children().children(".area__right").addClass("w100p");
        $(".area__left__toggleBtn").parent().children().children().children().children().children(".area__left").addClass("active");
        $(".area__left__toggleBtn").parent().children().children().children().children().children(".area__right").addClass("w100p");
        $(".area__left.active .btn-left").on("click", function () {
            $(".area__left").removeClass("active");
            $(this).hide();
            var mql = window.matchMedia("screen and (min-width: 768px)");
            if (mql.matches) {
                $(".area__left.close .btn-left, .area__left .btn-left").css({ display: "flex" });
            }
            else {
                $(".area__left.close .btn-left, .area__left .btn-left").css({ display: "" });
            }
        });
        setRecoilTreeOpen(true);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: `container admin-site workorder`, style: { "cursor": "default" } },
            React.createElement("section", { className: "content" },
                React.createElement("article", { className: `box list ${(isLoadingBox) ? "loading__box" : ""} ` },
                    React.createElement("div", { className: `box__body ${(nodata <= 0) ? "nodata" : ""}` },
                        React.createElement("section", { className: "swiper-section" },
                            React.createElement("div", { className: "swiper-container mySwiper ", style: { "cursor": "pointer" } },
                                React.createElement("div", { className: "swiper-wrapper" }, (tabMenuList) && tabMenuList.map((tabMenu, idx) => (React.createElement("div", { key: `tab_${idx.toString()}`, className: `swiper-slide tab ${(tabMenu.tabId === curTabMenu.tabId) ? "on" : ""}`, onClick: (e) => onClickTab(e), "data-value": JSON.stringify(tabMenu) },
                                    React.createElement("p", null, tabMenu.tabName))))))),
                        React.createElement("div", { className: "d-sm-tab" },
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectTabOption) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, curTabMenu.tabName),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, tabMenuList.map((tabMenu, idx) => (React.createElement("li", { key: `tab_m_${idx.toString()}`, className: `option tab ${(tabMenu.tabId === curTabMenu.tabId) ? "on" : ""}`, "data-value": JSON.stringify(tabMenu) }, tabMenu.tabName)))))),
                        (curTabMenu.tabUrl === CONST.URL_EHCWORKORDER) &&
                            React.createElement("div", { className: "tabcontent current" },
                                React.createElement(EhealthCheckMain, { setNodata: setNodata, setPopWin: props.setPopWin, nodata: nodata })),
                        (curTabMenu.tabUrl === CONST.URL_REQUESTWORKORDER) &&
                            React.createElement("div", { className: "tabcontent current" },
                                React.createElement(WorkInspectionMain, { setPopWin: props.setPopWin, setNodata: setNodata, nodata: nodata })),
                        (curTabMenu.tabUrl === CONST.URL_HISTORYWORKORDER) &&
                            React.createElement("div", { className: "tabcontent current" },
                                React.createElement(WorkHistoryList, { setPopWin: props.setPopWin, setNodata: setNodata, nodata: nodata })),
                        (curTabMenu.tabUrl === CONST.URL_DEVICECHANGEWORKORDER) &&
                            React.createElement("div", { className: "tabcontent current" },
                                React.createElement(ChangeMain, { setPopWin: props.setPopWin, setNodata: setNodata, nodata: nodata }))))),
            ((curTabMenu.tabUrl === CONST.URL_EHCWORKORDER) || (curTabMenu.tabUrl === CONST.URL_DEVICECHANGEWORKORDER)) &&
                React.createElement("a", { href: "#", className: "area__left__toggleBtn", onClick: (e) => onClickMoblieTreeMenu(e) },
                    React.createElement("span", { className: "hide" }, "\uD2B8\uB9AC\uBA54\uB274\uBCF4\uAE30")))));
}
export default ServiceRequestSubMain;
